import { Icon } from "@sellar-io/components";
import { DistributionSupplierBrowseList } from "../../components/DistributionSupplierBrowseList";

interface AddMoreToDeliveryStepProps {
  buyerPostcode: string | null;
  excludeSupplierId: number | null;
  onBack: () => void;
}

export const AddMoreToDeliveryStep = ({
  buyerPostcode,
  excludeSupplierId,
  onBack,
}: AddMoreToDeliveryStepProps) => {
  return (
    <div className="w-full flex-1 border-t border-zinc-200 bg-neutral-100 px-5 py-8">
      <div className="mx-auto w-full max-w-md">
        <div className="mb-5">
          <button
            type="button"
            onClick={onBack}
            className="mb-3 flex cursor-pointer items-center gap-2 text-zinc-800 hover:text-zinc-600"
          >
            <Icon icon="CHEVRON_LEFT" size={0.9} />
            <h2 className="text-xl font-semibold">Add more to your delivery</h2>
          </button>
          <p className="mt-1 text-sm text-zinc-500">
            Browse suppliers delivered by Sellar.
          </p>
        </div>
        <DistributionSupplierBrowseList
          buyerPostcode={buyerPostcode}
          excludeSupplierId={excludeSupplierId}
        />
      </div>
    </div>
  );
};

export default AddMoreToDeliveryStep;
